<template>
  <div>
    <template v-if="alternativeLabel">
      <label-required-field v-if="required" :label="label" @click="focus" />
      <label v-else @click="focus"> {{ label }} </label>
    </template>
    <v-text-field
      ref="input"
      outlined
      dense
      :autofocus="autofocus"
      :disabled="disabled"
      :hide-details="hideDetails"
      :hint="hint"
      :label="cLabel"
      :messages="messages"
      :persistent-hint="persistentHint"
      :placeholder="cPlaceholder"
      :prefix="prefix"
      :required="required"
      :suffix="suffix"
      :type="type"
      :value="value"
      @change="$emit('change', $event)"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import LabelRequiredField from "./LabelRequiredField";

export default {
  name: "VTextFieldDefault",

  components: { LabelRequiredField },

  props: {
    alternativeLabel: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    hideDetails: { type: [String, Boolean], default: "auto" },
    hint: { type: String, required: false },
    label: { type: String, required: true },
    messages: { type: [String, Array], required: false },
    persistentHint: { type: Boolean, default: false },
    placeholder: { type: String, default: undefined },
    prefix: { type: String, requried: false },
    required: { type: Boolean, default: false },
    suffix: { type: String, required: false },
    type: { type: String, default: "text" },
    value: { type: [String, Number], default: "" },
  },

  computed: {
    cLabel() {
      return this.alternativeLabel ? undefined : this.label;
    },

    cPlaceholder() {
      if (this.placeholder) return this.placeholder;
      return this.alternativeLabel ? this.label : undefined;
    },
  },

  methods: {
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>

<style>
</style>